type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
};

const FacebookWowReactionBadge = (props: Props) => {
  const { width = '18', height = '18', viewBox = '0 0 18 18' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <defs>
        <linearGradient id="fbWowFace" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFFADC" />
          <stop offset="100%" stopColor="#D89010" />
        </linearGradient>
      </defs>
      <circle cx="9" cy="9" r="9" fill="url(#fbWowFace)" />
      <path
        d="M 3.8 4.3 Q 5.4 3.0 7.0 4.3"
        stroke="#1A1A1A"
        strokeWidth="0.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M 11.0 4.3 Q 12.6 3.0 14.2 4.3"
        stroke="#1A1A1A"
        strokeWidth="0.5"
        strokeLinecap="round"
        fill="none"
      />
      <ellipse cx="5.4" cy="7.9" rx="1.15" ry="2.0" fill="#1A1A1A" />
      <ellipse cx="12.6" cy="7.9" rx="1.15" ry="2.0" fill="#1A1A1A" />
      <ellipse cx="9" cy="12.5" rx="1.75" ry="2.5" fill="#1A1A1A" />
    </svg>
  );
};

export default FacebookWowReactionBadge;
